export const CLEANED_PAYMENT_MEANS = {
  BookkeepingAccount: {
    _internalId: "BookkeepingAccount",
  },
  Description: {
    _internalId: "Description",
  },
};
